import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../../../colors';

export const useStyles = makeStyles({
  container: {
    border: `1px solid ${colors.neutral100}`,
    borderRadius: '8px !important',
    boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.04)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    fontWeight: 600,
    fontSize: 18,
    lineHeight: '24px',
    backgroundColor: 'white',
    maxHeight: 'calc(100vh - 383px)',
    overflowY: 'auto',
    overflowX: 'hidden',
    height: 'fit-content',
    flex: 2,
    minWidth: '45vw',
  },
  badgeSuccess: {
    backgroundColor: colors.success100,
    color: colors.success600,
    padding: '2px 10px',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: '0.12px',
    borderRadius: '100px',
    textTransform: 'capitalize',
  },
  produreContainer: {
    border: `1px solid ${colors.neutral100}`,
    borderRadius: '8px !important',
    boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.04)',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 4,
    minWidth: 680,
    width: '100%',
  },
  header: {
    padding: 24,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontWeight: 600,
    fontSize: 18,
    lineHeight: '24px',
    color: colors.neutral900,
  },
  headerSubTitle: {
    color: colors.neutral600,
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
  },
  body: {
    borderTop: `1px solid ${colors.neutral100}`,
    borderBottom: `1px solid ${colors.neutral100}`,
  },
  medicationBody: {
    display: 'flex',
    gap: 12,
    overflowY: 'auto',
  },
  card: {
    background: colors.white,
    padding: '24px',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    gap: 8,
    borderBottom: `1px solid ${colors.neutral100}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  cardTitle: {
    fontWeight: 700,
    fontSize: '22px',
    lineHeight: '24px',
    letterSpacing: '-0.22px',
  },
  cardSubTitle: {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
  },
  bodyUuid: {
    fontWeight: 400,
    fontSize: 36,
    lineHeight: '44px',
    color: colors.neutral900,
    fontfamily: 'Source Serif Pro',
  },
  bodyServiceName: {
    fontWeight: 600,
    fontSize: 18,
    lineHeight: '24px',
    color: colors.neutral900,
    fontfamily: 'Source Serif Pro',
  },
  codesHeading: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '20px',
  },
  codes: {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
  },
  footer: {
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
  },
  footerText: {
    textAlign: 'center',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral900,
  },
  footerBtn: {
    textTransform: 'none !important',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.primary500,
    maxHeight: '20px',
  },
  addBtn: {
    textTransform: 'none !important',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '20px',
    width: '100%',
    color: colors.primary500,
    display: 'flex',
    gap: 8,
    '& svg': {
      width: 18,
      height: 18,
    },
  },
  checkIcon: {
    width: 16.67,
    height: 16.67,
    '& path': {
      fill: colors.success500,
    },
  },
  crossIcon: {
    width: 19,
    height: 19,
    '& path': {
      fill: colors.destructive500,
    },
  },
  isBorder: {
    borderBottom: `1px solid ${colors.neutral100}`,
  },
  iconContainer: {
    width: '44px',
    height: '44px',
    padding: '12px',
    gap: '8px',
    borderRadius: '6px',
  },
  aiText: {
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '24px',
    color: colors.neutral900,
    marginTop: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  criteriaText: {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral700,
  },
  badgePotential: {
    backgroundColor: `${colors.indigo100} !important`,
    color: `${colors.indigo600} !important`,
    border: 'none !important',
    padding: '2px 10px',
    fontSize: '12px',
    fontWeight: 600,
    borderRadius: '100px',
  },
  discardButton: {
    color: colors.destructive600,
    borderColor: colors.destructive300,
    backgroundColor: colors.white,
    '&:hover': {
      backgroundColor: colors.destructive50,
    },
  },
  confirmButton: {
    color: colors.success600,
    borderColor: colors.success500,
    backgroundColor: colors.white,
    '&:hover': {
      backgroundColor: colors.success50,
    },
  },
  reasoningLink: {
    paddingBottom: 10,
  },
  viewReasoningText: {
    color: colors.primary500,
    cursor: 'pointer',
    fontWeight: 500,
    '&:hover': {
      color: colors.primary600,
    },
  },
});
